import React, { useState } from 'react';
import { connect } from 'react-redux';
import ListItem from './ListItem';
import Pagination2 from '../../../components/Pagination2';
import { domManipulator } from '../../../utils';
import Spin from '../../../components/loading';
import * as rseeDiscountsActions from '../../../redux/rseeDiscounts/actions';
import generateClassName from '../../../utils/generateClassName';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

const RseeDiscountsList = props => {
  const [sortedColumn, setSortedColumn] = useState('');

  const sortTable = query => {
    setSortedColumn(query);
    props.sortTable(query);
  };

  const activateRseeDiscount = id => {
    props.activateRseeDiscount(id).then(() => {
      const { activateRseeDiscountError, activateRseeDiscountFailed, activateRseeDiscountMessage } = props;
      if (
        activateRseeDiscountError == false &&
        activateRseeDiscountMessage == null &&
        activateRseeDiscountFailed == false
      ) {
        AlertAndConfirmation({
          title: locales('titles.editionsDoneSuccessfully'),
          text: '',
          type: 'success',
        });
        const query = props.buildSearchQuery(props.pageNumber, props.pageSize);
        props.getMyRseeDiscountsList(query);
      } else {
        domManipulator.scrollToTop();
      }
    });
  };

  const {
    sortType,
    activateRseeDiscountLoading,
    getMyRseeDailyWorkingHoursLoading,

    activateRseeDiscountError,
    getMyRseeDailyWorkingHoursError,

    activateRseeDiscountFailed,
    getMyRseeDailyWorkingHoursFailed,

    activateRseeDiscountMessage,
    getMyRseeDailyWorkingHoursMessage,
  } = props;

  return (
    <>
      <Spin spinning={activateRseeDiscountLoading || getMyRseeDailyWorkingHoursLoading}>
        {activateRseeDiscountError ||
        (getMyRseeDailyWorkingHoursError && (
          <div className="alert alert-danger">{locales('messages.server.error')}</div>
        ))}
        {activateRseeDiscountFailed ||
        (getMyRseeDailyWorkingHoursFailed && (
          <div className="alert alert-danger">
            {activateRseeDiscountMessage || getMyRseeDailyWorkingHoursMessage}
          </div>
        ))}
        <table className="table table-hover table-light table-striped">
          <thead className="thead-dark">
          <tr>
            <th className="text-center">{locales('labels.row')}</th>
            <th onClick={() => sortTable('cafeName')} className="text-center pointer">
              <i name="cafeName" className={generateClassName('cafeName', sortedColumn, sortType)}/>
              {locales('fields.cafe.name')}
            </th>
            <th onClick={() => sortTable('fromDate')} className="text-center pointer">
              <i name="fromDate" className={generateClassName('fromDate', sortedColumn, sortType)}/>
              {locales('labels.from.date')}
            </th>
            <th onClick={() => sortTable('toDate')} className="text-center pointer">
              <i name="toDate" className={generateClassName('toDate', sortedColumn, sortType)}/>
              {locales('labels.to.date')}
            </th>
            <th className="text-center">{locales('labels.status')}</th>
            <th onClick={() => sortTable('createdAt')} className="text-center pointer">
              <i name="createdAt" className={generateClassName('createdAt', sortedColumn, sortType)}/>
              {locales('labels.request.date.time')}
            </th>
            <th className="text-center"></th>
            <th className="text-center"></th>
          </tr>
          </thead>
          <tbody>
          {props.myRseeDiscountsList && props.myRseeDiscountsList.length ? (
            props.myRseeDiscountsList.map((rseeDiscountListItem, ix) => (
              <ListItem
                activateRseeDiscount={activateRseeDiscount}
                key={rseeDiscountListItem.id}
                id={rseeDiscountListItem.id}
                ix={ix}
                fromDate={rseeDiscountListItem.fromDate}
                cafeName={rseeDiscountListItem.cafeName}
                toDate={rseeDiscountListItem.toDate}
                status={rseeDiscountListItem.status}
                createdAt={rseeDiscountListItem.createdAt}
                pageNumber={props.pageNumber}
                pageSize={props.pageSize}
              />
            ))
          ) : (
            <tr className="text-center">
              <td className="alert alert-info" colSpan="12">
                {locales('alerts.noRecord')}
              </td>
            </tr>
          )}
          </tbody>
        </table>
        <footer className="d-flex justify-content-center">
          <div className="pagination-container">
            <Pagination2
              totalRecords={props.totalRecords || 0}
              pageLimit={props.itemsPerPage}
              pageNeighbours={2}
              onPageChanged={props.onPageChange}
              currentPage={props.pageNumber}
            />
          </div>
        </footer>
      </Spin>
    </>
  );
};

const mapStateToProps = state => {
  return {
    getMyRseeDailyWorkingHoursLoading: state.workingHoursReducer.getMyRseeDailyWorkingHoursLoading,
    getMyRseeDailyWorkingHoursFailed: state.workingHoursReducer.getMyRseeDailyWorkingHoursFailed,
    getMyRseeDailyWorkingHoursError: state.workingHoursReducer.getMyRseeDailyWorkingHoursError,
    getMyRseeDailyWorkingHoursMessage: state.workingHoursReducer.getMyRseeDailyWorkingHoursMessage,

    activateRseeDiscountError: state.rseeDiscountsReducer.activateRseeDiscountError,
    activateRseeDiscountFailed: state.rseeDiscountsReducer.activateRseeDiscountFailed,
    activateRseeDiscountMessage: state.rseeDiscountsReducer.activateRseeDiscountMessage,
    activateRseeDiscountLoading: state.rseeDiscountsReducer.activateRseeDiscountLoading,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getMyRseeDiscountsList: query => dispatch(rseeDiscountsActions.getMyRseeDiscountsList(query)),
    activateRseeDiscount: id => dispatch(rseeDiscountsActions.activateRseeDiscount(id)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RseeDiscountsList);
